export default "<div class=\"app-auth-content h-100\"></div>\r\n";